import React, {
  useCallback,
} from 'react';
import { ListParams } from '../../types/main';
import OrganizationService from '../../services/OrganizationService';
import { SelectProps } from './types';
import BaseSearchSelect from './BaseSearchSelect';

const OrganizationField = (props: SelectProps) => {
  const defaultParams: ListParams = {
    page_size: 10,
    sort_key: 'common_name',
    sort_dir: 'ASC',
  };

  const searchOptionsHandler = useCallback(async (params: ListParams) => {
    const records = await OrganizationService.list({ ...defaultParams, ...params});

    return records.items?.map((item) => ({
      label: item.common_name,
      id: item.id,
    })) || [];
  }, [defaultParams]);

  return (
    <BaseSearchSelect
      searchOptions={searchOptionsHandler}
      {...props}
    />
  );
};

export default OrganizationField;
